<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <b-alert show :variant="alert.type" v-for="alert in alerts" :key="alert.title" dismissible>
                    <strong>{{ alert.title }}:</strong> {{ alert.msg }}
                </b-alert>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    props: {
        alerts: Array,
    },
}
</script>

<style>
    .alert {
        opacity: .9;
        /*transition: top 1s linear;*/
    }
    .alert-holder {
        position: absolute;
        right: 0px;
        bottom: -15px;
        padding: 0px; 
        margin: 0px;
    }
</style>
